import { render, staticRenderFns } from "./ProductsByCategory.vue?vue&type=template&id=5f53c0a9&scoped=true&"
import script from "./ProductsByCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsByCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductsByCategory.vue?vue&type=style&index=0&id=5f53c0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53c0a9",
  null
  
)

export default component.exports